export const SalesPerformanceTypes = {
  IGetSalesPerformanceService: Symbol("IGetSalesPerformanceService"),
  IGetProductService: Symbol("IGetProductService"),
};
